import React from 'react';
//import PropTypes from 'prop-types';
import i18next from 'i18next';
import { translate } from 'react-i18next';
import { Form } from 'antd';
import { debounce, isEmpty, pickBy, isEqual, get } from 'lodash';
import moment from 'moment';
import { Collapse } from 'react-collapse';

import LangSwitcher from '../../../../../dashboard/components/AdminContentLangSwitcher';
import MultiLangField from 'Parts/ui/components/fields/MultiLangField';
//import Tooltip from 'Parts/ui/components/FundkyTooltip';
import Button from 'Parts/ui/components/FundkyButton';
import FakeField from 'Parts/ui/components/fields/FakeField';
import UploadCropField from 'Parts/ui/components/fields/UploadCropField';
import TextField from 'Parts/ui/components/fields/TextField';
import TextAreaField from 'Parts/ui/components/fields/TextAreaField';
import MoneyField from 'Parts/ui/components/fields/MoneyField';
import SelectField from 'Parts/ui/components/fields/SelectField';
import NumberField from 'Parts/ui/components/fields/NumberField';
import CheckboxField from 'Parts/ui/components/fields/CheckboxField';
import DatePickerField from 'Parts/ui/components/fields/DatePickerField';
import CancelAndSaveButtons from '../../../../../dashboard/components/CancelAndSaveButtons';
import { moneyFormat } from 'Parts/common/moneyFormat';

import { CAMPAIGN_TEMPLATE_SOLO, CAMPAIGN_TEMPLATE_TEAMS, CAMPAIGN_TEMPLATE_PARTICIPANTS } from '../../../../../campaign/campaignUtils';

import {
  getLanguageKeyById,
  getPlatformLanguages,
  getLanguageKeyByName,
  getLanguageNameByKey
} from 'Parts/common/langUtils';
import { getDateValue } from 'Parts/common/dateUtils';

import eventAdminCampaignTicketFormEN from './locales/EventAdminCampaignTicketForm_en.json';
import eventAdminCampaignTicketFormFR from './locales/EventAdminCampaignTicketForm_fr.json';

import './EventAdminCampaignTicketForm.less';

class EventAdminCampaignTicketForm extends React.Component {
  constructor(props) {
    super(props);

    if (props.ticketId !== 'temp') {
      props.fetchTicket(
        props.campaign.id,
        props.ticketId,
        {
          showDescription: true,
          showAdvantage: true,
          showMedia: true
        },
        true
      );
    }

    this.defaultLang = getLanguageKeyById(get(props, 'campaign.languageId', 0));
    this.defaultLangId = get(props, 'campaign.languageId', 0);

    this.hidePublicPage = undefined
    this.hidePublicPageEnabled = true

    this.checkIfPublicPageIsNeeded = this.checkIfPublicPageIsNeeded.bind(this);

    this.state = {
      showPriceDetails: true,//false,
      contentLang: this.defaultLang,
      ticketType: props.ticket.typeId || null,
      disableTicketPerTransaction: false
    };

    this.UploadCropField = React.createRef();

    this.emitChangeDebounced = debounce(this.emitChange, 250);

    i18next.addResourceBundle('en', 'EventAdminCampaignTicketForm', eventAdminCampaignTicketFormEN);
    i18next.addResourceBundle('fr', 'EventAdminCampaignTicketForm', eventAdminCampaignTicketFormFR);
  }

  checkIfPublicPageIsNeeded() {
    let canCreate = document.getElementById("allowCreatingTeams").checked
    let canJoin = document.getElementById("allowJoiningTeams").checked

    this.hidePublicPageEnabled = !canCreate && !canJoin
    if(!this.hidePublicPageEnabled) {
      this.props.form.setFieldsValue({ ["hidePublicPage"]: false });
    }
  }

  componentDidMount() {
    if (get(this.props, 'ticket.participation')) {
      this.setState({
        disableTicketPerTransaction: true
      });
      this.props.form.setFieldsValue({
        ticket_transactions: 1
      });
    } else {
      this.setState({
        disableTicketPerTransaction: false
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      isEqual(prevProps.ticket, {}) &&
      !isEqual(this.props.ticket, {}) &&
      this.props.ticket.advantage
    ) {
      this.setState({
        showPriceDetails: true
      });
    }

    if (get(prevProps, 'ticket.typeId') !== get(this.props, 'ticket.typeId')) {
      this.setState({
        ticketType: this.props.ticket.typeId
      });
    }

    if (get(prevProps, 'ticket.participation') !== get(this.props, 'ticket.participation') && get(this.state, 'disableTicketPerTransaction') !== get(this.props, 'ticket.participation')) {
      if (get(this.props, 'ticket.participation')) {
        this.setState({
          disableTicketPerTransaction: true
        });
        this.props.form.setFieldsValue({
          ticket_transactions: 1
        });
      } else {
        this.setState({
          disableTicketPerTransaction: false
        });
      }
    }
  }

  componentWillUnmount() {
    if (!isEmpty(this.props.ticket)) this.props.clearTicket();

    this.props.form.resetFields();
  }

  handleSubmitTicket = e => {
    e.preventDefault();
    const {
      form,
      ticket,
      ticketId,
      languages,
      createTicket,
      updateTicket,
      campaign,
      isEditing,
      isAdding
    } = this.props;
    const { validateFields, isFieldTouched } = form;
    // The force option is required because we have dynamic rules
    // See https://github.com/react-component/form/issues/130
    validateFields({ force: true }, (err, _values) => {
      if (!err) {
        let values;
        if (isAdding) {
          // CREATE
          values = _values;
        } else if (isEditing) {
          // UPDATE
          values = pickBy(_values, (value, key) => isFieldTouched(key));

          /* Add untouched field modified by other function */

          // ticket_advantageAmount modified by displayPriceDetails()
          if (
            !values.ticket_advantageAmount &&
            _values.ticket_advantageAmount != ticket.advantageAmount
          )
            Object.assign(values, { ticket_advantageAmount: _values.ticket_advantageAmount });

          getPlatformLanguages(languages).forEach(({ key }) => {
            // advantage_description_[languageKey] modified by displayPriceDetails()
            if (
              !values['advantage_description_' + key] &&
              _values['advantage_description_' + key] !==
                get(ticket, `advantage.${getLanguageNameByKey(key, false)}.description`, null)
            )
              Object.assign(values, {
                ['advantage_description_' + key]: _values['advantage_description_' + key]
              });

            // Add deleted image
            if (
              !values['ticket_image_' + key] &&
              _values['ticket_image_' + key] === null &&
              get(ticket, `media.image.${getLanguageNameByKey(key, false)}`, null)
            )
              Object.assign(values, { ['ticket_image_' + key]: null });
          });

          // ticket_seats modified by handleChangeTicketType()
          if (!values.ticket_seats && _values.ticket_seats != ticket.seats)
            Object.assign(values, { ticket_seats: _values.ticket_seats });

          // ticket_price and ticket_advantageAmount must be sent together
          if (values.ticket_price >= 0 || values.ticket_advantageAmount >= 0) {
            Object.assign(values, {
              ticket_price: _values.ticket_price,
              ticket_advantageAmount: _values.ticket_advantageAmount
            });
          }
        }

        const languagesArray = getPlatformLanguages(languages);

        const ticket_images = languagesArray
          .filter(langObj => {
            const img = this.state['ticket_image_' + langObj.key];
            return img || (img === null && isEditing) ? true : false;
          })
          .map(langObj => {
            const img = this.state['ticket_image_' + langObj.key];
            return {
              languageId: langObj.id,
              ...(img ? { image: img } : {})
            };
          });

        const ticket_descriptions = languagesArray
          .filter(langObj => {
            const name = values['ticket_name_' + langObj.key];
            const desc = values['ticket_description_' + langObj.key];
            return name || desc ? true : false;
          })
          .map(langObj => {
            const name = _values['ticket_name_' + langObj.key];
            const desc = _values['ticket_description_' + langObj.key];
            return {
              languageId: langObj.id,
              name: name,
              description: desc
            };
          });

        // TODO: I don't remember what this was for
        const ticket_descriptions_validation = ticket_descriptions
          .filter(desc => (desc.name && desc.description) ||
            (!desc.name && !desc.description && desc.languageId != this.defaultLangId)
          );

        const ticket_advantages = languagesArray
          .filter(langObj => {
            const desc = values['advantage_description_' + langObj.key];
            const lang = langObj.name.toLowerCase();
            const initialValue = get(this.props, `ticket.advantage.${lang}.description`);

            return (desc && desc !== '') || (initialValue && desc === '' && isEditing) ? true : false;
          })
          .map(langObj => {
            const desc = values['advantage_description_' + langObj.key];
            return {
              languageId: langObj.id,
              description: desc
              //...(desc !== '' ? { description: desc } : {})
            };
          });

        const ticket_values = {
          forceParticipation: _values.forceParticipation,
          allowJoiningTeams:  _values.allowJoiningTeams,
          allowCreatingTeams: _values.allowCreatingTeams,
          hidePublicPage:     _values.hidePublicPage,
          // Total price
          ...(values.ticket_price >= 0 ? { totalPrice: values.ticket_price } : {}),
          // Advantage amount
          ...(values.ticket_advantageAmount >= 0
            ? { advantageAmount: values.ticket_advantageAmount || 0 }
            : {}),
          // Ticket type id
          //...(values.ticket_type ? { typeId: values.ticket_type } : { typeId: 1 /* TODO: Remove this default value when its ready */ }),
          // Ticket quantity
          ...(values.ticket_quantity || values.ticket_transactions || values.forceParticipation !== undefined
            ? {
                quantity: _values.ticket_quantity,
                //forceParticipation: _values.forceParticipation ? true : false, //TODO: set the API value and uncomment
                limitPerTransaction: _values.ticket_transactions || 1
                  // _values.forceParticipation
                  // ?  1
                  // : _values.ticket_transactions || null // null allowed
              }
            : {}),
          // Ticket seats
          ...( // For group type ticket
            (values.ticket_seats && _values.ticket_type === 2) ||
            values.ticket_type === 2
              ? { seats: _values.ticket_seats, typeId: _values.ticket_type }
              : // For individual type ticket
                (_values.ticket_type === 1 && _values.ticket_seats !== 1) ||
                values.ticket_type === 1
                  ? { seats: 1, typeId: _values.ticket_type }
                  : {}
          ),
          // Start on
          startOn: values.ticket_start
              ? getDateValue(values.ticket_start)
              : values.ticket_start === null
                ? null
                : get(this.props, 'ticket.startOn')
                  ? getDateValue(moment(this.props.ticket.startOn))
                  : isAdding
                    ? getDateValue(moment())
                    : null,
          // End on
          endOn: values.ticket_end
            ? getDateValue(values.ticket_end)
            : values.ticket_end === null
              ? null
              : get(this.props, 'ticket.endOn')
                ? getDateValue(moment(this.props.ticket.endOn))
                : null,
          // Display Availability
          ...(values.hideAvailability !== undefined
            ? { displayAvailability: !values.hideAvailability }
            : {}
          )
        };

        /* UPDATE */
        if (isEditing && !isEmpty(values)) {
          updateTicket(
            campaign.id,
            ticketId,
            isEmpty(ticket_values) ? null : ticket_values,
            isEmpty(ticket_descriptions) ? null : ticket_descriptions,
            isEmpty(ticket_advantages) ? null : ticket_advantages,
            isEmpty(ticket_images) ? null : ticket_images,
            true,
            true,
            true
          );
        } else if (isAdding && !isEmpty(values)) {
        /* CREATE */
          const formValues = {
            ...ticket_values,
            typeId: 1,
            ...(isEmpty(ticket_descriptions) ? {} : { descriptions: ticket_descriptions }),
            ...(isEmpty(ticket_advantages) ? {} : { advantages: ticket_advantages }),
            ...(isEmpty(ticket_images) ? {} : { images: ticket_images }),
            weight: 100
          };

          createTicket(
            campaign.id,
            formValues,
            (this.props.tickets.results && this.props.tickets.results.map(ticket => ticket.id)) ||
              []
          );
        }
      } else {
        // Force default language display
        if (
          err['ticket_name_' + this.defaultLang] ||
          err['ticket_description_' + this.defaultLang]
        ) {
          this.setState({
            contentLang: this.defaultLang
          });
        }
      }
    });
  };

  handleCropComplete = image => {
    this.setState({
      [`ticket_image_${this.state.contentLang}`]: image
    });
  };

  handleOnChangeImage = ({ target }) => {
    this.emitChangeDebounced(target);
  };

  emitChange = target => {
    const value = target.value;
    if (value) {
      const errors = this.props.form.getFieldError(target.id);
      this.setState({
        canDraft: !errors ? true : false
      });
    }
  };

  handleChangeLanguage = lang => {
    if (this.state.contentLang !== lang)
      this.setState({ contentLang: lang }, () => this.props.form.validateFields({ force: true }));
  };

  displayPriceDetails = () => {
    this.setState(
      {
        showPriceDetails: !this.state.showPriceDetails
      },
      () => {
        if (this.state.showPriceDetails) {
          const amount = this.props.form.getFieldValue('ticket_price');
          this.props.form.setFieldsValue({
            ticket_donationAmount: amount
          });
        } else {
          let advantage_descriptions = {};
          getPlatformLanguages(this.props.languages).forEach(({ key }) => {
            advantage_descriptions['advantage_description_' + key] = '';
          });
          this.props.form.setFieldsValue({
            ticket_donationAmount: 0,
            ticket_advantageAmount: 0,
            ...advantage_descriptions
          });
        }
      }
    );
  };

  updateDonationAmountFromTotalPrice = price => {
    if (this.state.showPriceDetails) {
      const advantage = this.props.form.getFieldValue('ticket_advantageAmount');

      this.props.form.setFieldsValue({
        ticket_donationAmount: (Number(price) - Number(advantage)).toFixed(2)
      });
    }
  };

  updateDonationAmountFromAdvantageAmount = advantage => {
    if (this.state.showPriceDetails) {
      const price = this.props.form.getFieldValue('ticket_price');

      this.props.form.setFieldsValue({
        ticket_donationAmount: (Number(price) - Number(advantage)).toFixed(2)
      });
    }
  };

  getInitialValues = (obj = {}, prop = null) => {
    let lang,
      key,
      value = [];
    for (lang in obj) {
      key = getLanguageKeyByName(lang);
      value[key] = prop ? obj[lang][prop] : obj[lang];
    }
    return value;
  };

  handleChangeTicketType = typeId => {
    this.props.form.setFieldsValue({ ticket_seats: 1 });
    this.setState({
      ticketType: typeId
    });
  };

  handleDeleteImage = fieldId => {
    this.setState({ [fieldId]: null });
  };

  // handleForceParticipationCheckbox = (e, a) => {
  //   let value = e.target.checked;
  //   if (value) {
  //     this.setState({
  //       disableTicketPerTransaction: true
  //     });
  //     this.props.form.setFieldsValue({
  //       ticket_transactions: 1
  //     });
  //   } else {
  //     this.setState({
  //       disableTicketPerTransaction: false
  //     });
  //   }
  // };

  render() {
    const { props, state, handleForceParticipationCheckbox } = this;
    const { t, form, ticket, locale, isEditing, isAdding, organization, campaign } = props;
    const { showPriceDetails, contentLang, ticketType, disableTicketPerTransaction } = state;
    const title = isEditing ? t('edit-a-ticket') : t('add-a-ticket');

    const maxTickets = form.getFieldValue('ticket_quantity') || null;
    const maxTicketsByTransaction = form.getFieldValue('ticket_transactions') || null;
    //const ticketType = form.getFieldValue('ticket_type') || null;
    const ticketPrice = form.getFieldValue('ticket_price') || null;
    const initialDonationAmount =
      Number(ticket.totalPrice) >= 0
        ? Number(ticket.advantageAmount) >= 0
          ? (Number(ticket.totalPrice) - Number(ticket.advantageAmount)).toFixed(2)
          : Number(ticket.totalPrice).toFixed(2)
        : (ticketPrice && Number(ticketPrice).toFixed(2)) || '0';
    
    return (
      <Form onSubmit={this.handleSubmitTicket} className="EventAdminCampaignTicketForm">
        <h3>{title}</h3>
        {/* <p><b>{t('participation-warning')}</b></p> */}
        <LangSwitcher
          form={form}
          defaultLanguage={this.defaultLang}
          forceLanguage={contentLang}
          handleChange={this.handleChangeLanguage}
          dropdownClassName="EventAdminCampaignTicketForm__LanguageSwitcher--dropdown"
          // disabled={disabled}
          // changeHasHappened={changeHasHappened}
        />
        {/* <MultiLangField
          form={form}
          showLangSelect={false}
          contentLang={contentLang}
          locale={this.defaultLang}
          requiredType="none"
          initialValue={
            (ticket.media &&
              ticket.media.image &&
              this.getInitialValues(ticket.media.image, 'image')) ||
            null
          }
        >
          <UploadCropField
            ref={this.UploadCropField}
            label={t('ticket-picture')}
            form={form}
            fieldId="ticket_image"
            icon={['fal', 'image']}
            uploadTitle={t('ticket-picture')}
            handleCropConfirm={this.handleCropComplete}
            onChange={this.handleOnChangeImage}
            erasable
            handleDelete={this.handleDeleteImage}
          />
        </MultiLangField> */}

        <CheckboxField
          label={t('can-create-a-team-label')}
          form={form}
          fieldId="allowCreatingTeams"
          initialValue={ticket.allowCreatingTeams ? true : false}
          onChange={this.checkIfPublicPageIsNeeded}
          disabled={campaign.typeId === CAMPAIGN_TEMPLATE_SOLO || campaign.typeId === CAMPAIGN_TEMPLATE_PARTICIPANTS}
        />

        <CheckboxField
            label={t('can-join-a-team-label')}
            form={form}
            fieldId="allowJoiningTeams"
            initialValue={ticket.allowJoiningTeams ? true : false}
            onChange={this.checkIfPublicPageIsNeeded}
            disabled={campaign.typeId === CAMPAIGN_TEMPLATE_SOLO || campaign.typeId === CAMPAIGN_TEMPLATE_PARTICIPANTS}
        />

        <CheckboxField
          label={t('hide-public-page-label')}
          form={form}
          fieldId="hidePublicPage"
          initialValue={isEditing ? ticket.hidePublicPage ? true : false : true}
          disabled={!this.hidePublicPageEnabled}
        />

        <MultiLangField
          form={form}
          showLangSelect={false}
          contentLang={contentLang}
          locale={this.defaultLang}
          requiredType="locale"
          initialValue={
            (ticket.description && this.getInitialValues(ticket.description, 'name')) || null
          }
        >
          <TextField
            label={t('ticket-name-label')}
            form={form}
            fieldId="ticket_name"
            maxlength={125}
            counter
            requiredMessage={t('ticket-name-required')}
            maximumMessage={t('ticket-name-maximum', { max: 125 })}
          />
        </MultiLangField>
      
        <MultiLangField
          form={form}
          showLangSelect={false}
          contentLang={contentLang}
          locale={this.defaultLang}
          requiredType="locale"
          initialValue={
            (ticket.description && this.getInitialValues(ticket.description, 'description')) || null
          }
        >
          <TextAreaField
            label={t('ticket-description-label')}
            form={form}
            fieldId="ticket_description"
            placeholder=""
            requiredMessage={t('ticket-description-required')}
            maxlength={500}
          />
        </MultiLangField>
        <FakeField
          label={t('ticket-price-label')}
          required
          data={
            <>
              <MoneyField
                className={`label-top ${!showPriceDetails ? 'more' : ''}`}
                form={form}
                fieldId="ticket_price"
                label={showPriceDetails ? t('total-price-label') : null}
                locale={locale}
                customValidation={[
                  {
                    validator: (rule, value, callback) => {
                      return parseFloat(value) === 0 || parseFloat(value) >= 5 ? callback() : callback(true);
                    },
                    message: t('MoneyField:min-amount', { min: (moneyFormat(5, locale)) })
                  }
                ]}
                more={
                  !showPriceDetails ? (
                    <Button
                      action={{ func: this.displayPriceDetails }}
                      type="text-primary"
                      text={t('details')}
                      className="price-details-button"
                      icon={['fas', 'plus']}
                      iconPosition="before"
                      disabled={false}
                    />
                  ) : null
                }
                validationInside
                onChange={this.updateDonationAmountFromTotalPrice}
                required
                //minimum={0}
                maximum={10000}
                initialValue={ticket.totalPrice || 0}
              />
              <Collapse isOpened={showPriceDetails && organization.typeId === 2}>
                <div className="price-amounts">
                  <MoneyField
                    className="label-top"
                    label={t('donation-amount-label')}
                    form={form}
                    fieldId="ticket_donationAmount"
                    locale={locale}
                    validationInside
                    disabled
                    minimum={0}
                    maximum={ticketPrice || 10000}
                    initialValue={initialDonationAmount}
                  />
                  <MoneyField
                    className="label-top more"
                    label={t('advantage-amount-label')}
                    form={form}
                    fieldId="ticket_advantageAmount"
                    locale={locale}
                    // more={
                    //   <Button
                    //     action={{ func: this.displayPriceDetails }}
                    //     type="text-primary"
                    //     text={t('remove')}
                    //     className="price-remove-button"
                    //     icon={['fas', 'times']}
                    //     iconPosition="before"
                    //     disabled={false}
                    //   />
                    // }
                    validationInside
                    onChange={this.updateDonationAmountFromAdvantageAmount}
                    minimum={0}
                    maximum={ticketPrice || 10000}
                    initialValue={ticket.advantageAmount || 0}
                  />
                </div>
                <p><b>{t('price-info-label')}</b>{t('price-info')} <a href={t('price-more-info-link-url')} target="_blank" rel="noopener noreferrer">{t('price-more-info-link')}</a></p>
                <MultiLangField
                  className="label-top"
                  form={form}
                  showLangSelect={false}
                  contentLang={contentLang}
                  locale={this.defaultLang}
                  requiredType="none"
                  initialValue={
                    (ticket.advantage && this.getInitialValues(ticket.advantage, 'description')) ||
                    null
                  }
                >
                  <TextAreaField
                    label={t('advantage-description-label')}
                    form={form}
                    fieldId="advantage_description"
                    placeholder=""
                    maxlength={255}
                  />
                </MultiLangField>
                <p>{t('advantage-description-info')}</p>
              </Collapse>
            </>
          }
        />
        {/* TODO: Uncomment when ready to have different ticket type
        <SelectField
          label={t('ticket-type-label')}
          form={form}
          fieldId="ticket_type"
          optionsArray={[
            { value: 1, text: t('individual') },
            //{ value: 2, text: t('grouped') }
          ]}
          required
          requiredMessage="message Test"
          notice={t('ticket-type-info')}
          initialValue={ticket.typeId || 1}
          onChange={this.handleChangeTicketType}
        />
        <Collapse isOpened={ticketType === 2}>
          <NumberField
            label={t('ticket-seats-label')}
            form={form}
            fieldId="ticket_seats"
            fieldOptions={{
              //initialValue: initialValue,
              //validateTrigger: ['onChange', 'onKeyUp'],
              rules: [
                {
                  validator: (rule, value, callback) => {
                    const _value = isNaN(parseFloat(value)) ? 0 : parseFloat(value);
                    return _value >= 1 ||
                      (ticketType !== 2 && value === undefined) ||
                      (ticketType !== 2 && value === null) ||
                      (ticketType !== 2 && value === '')
                      ? callback()
                      : callback(true);
                  },
                  message: t('number-minimum', { min: 1 })
                },
                {
                  validator: (rule, value, callback) => {
                    const _value = isNaN(parseFloat(value)) ? 0 : parseFloat(value);
                    return _value <= 65535 ? callback() : callback(true);
                  },
                  message: t('number-maximum', { max: 65535 })
                }
              ]
            }}
            initialValue={ticket.seats || 1}
          />
        </Collapse> */}
        <NumberField
          label={t('ticket-available-label')}
          form={form}
          fieldId="ticket_quantity"
          fieldOptions={{
            //initialValue: initialValue,
            //validateTrigger: ['onChange', 'onKeyUp'],
            rules: [
              {
                required: true,
                message: t('ticket-available-required')
              },
              {
                validator: (rule, value, callback) => {
                  const _value = isNaN(parseFloat(value)) ? 0 : parseFloat(value);
                  return _value >= 1 ? callback() : callback(true);
                },
                message: t('number-minimum', { min: 1 })
              },
              {
                validator: (rule, value, callback) => {
                  const _value = isNaN(parseFloat(value)) ? 0 : parseFloat(value);
                  return _value <= 65535 ? callback() : callback(true);
                },
                message: t('number-maximum', { max: 65535 })
              }
            ]
          }}
          initialValue={ticket.quantity || null}
        />
        <CheckboxField
          fieldId="hideAvailability"
          form={form}
          label={t('hide-ticket-availability-label')}
          tooltip={t('hide-ticket-availability-tooltip')}
          initialValue={ticket.displayAvailability || isAdding ? false : true}
        />
        {campaign.typeId !== CAMPAIGN_TEMPLATE_SOLO &&
          <CheckboxField
            fieldId="forceParticipation"
            form={form}
            label={t('force-participation-label')}
            tooltip={t('force-participation-tooltip')}
            initialValue={ticket.forceParticipation ? true : false}
            //onChange={handleForceParticipationCheckbox}
          /> ||
          null
        }
        <NumberField
          label={t('ticket-transactions-label')}
          form={form}
          fieldId="ticket_transactions"
          notice={
            maxTicketsByTransaction && Number(maxTicketsByTransaction) > 0
              ? t('ticket-transactions-notice', { count: maxTicketsByTransaction })
              : null
          }
          fieldOptions={{
            rules: [
              {
                validator: (rule, value, callback) => {
                  const _value = parseFloat(value);
                  return _value >= 1 || isNaN(_value) ? callback() : callback(true);
                },
                message: t('number-minimum', { min: 1 })
              },
              ...(maxTickets
                ? [
                    {
                      validator: (rule, value, callback) => {
                        const _value = isNaN(parseFloat(value)) ? 0 : parseFloat(value);
                        return _value <= Number(maxTickets) ? callback() : callback(true);
                      },
                      message: t('number-maximum', { max: Number(maxTickets) })
                    }
                  ]
                : [
                    {
                      validator: (rule, value, callback) => {
                        const _value = isNaN(parseFloat(value)) ? 0 : parseFloat(value);
                        return _value <= 65535 ? callback() : callback(true);
                      },
                      message: t('number-maximum', { max: 65535 })
                    }
                  ])
            ]
          }}
          initialValue={ticket.limitPerTransaction || 1}
          disabled={disableTicketPerTransaction}
        />
        <DatePickerField
          label={t('ticket-start-label')}
          form={form}
          fieldId="ticket_start"
          allowClear={true}
          //required
          //future
          //past={this.props.eventEndOn || null}
          hasFeedback
          initialValue={
            (ticket.startOn && moment(ticket.startOn)) ||
            (ticket.startOn !== null && moment()) /*||
            (this.props.eventEndOn && moment(this.props.eventEndOn))*/
          }
        />
        <DatePickerField
          label={t('ticket-end-label')}
          form={form}
          fieldId="ticket_end"
          allowClear={true}
          //required
          //future
          //past={this.props.eventEndOn || null}
          hasFeedback
          initialValue={
            (ticket.endOn && moment(ticket.endOn)) /*||
            (this.props.eventEndOn && moment(this.props.eventEndOn))*/
          }
        />
        <CancelAndSaveButtons
          isSavingInProgress={
            this.props.isSaveTicketInProgress || this.props.isUpdateTicketInProgress
          }
          overwriteSubmit={this.handleSubmitTicket}
          onClickCancel={this.props.handleCancelAddTicket}
        />
      </Form>
    );
  }
}

EventAdminCampaignTicketForm.propTypes = {};

export default translate('EventAdminCampaignTicketForm')(EventAdminCampaignTicketForm);
